module.exports = __webpack_public_path__ + "static/media/icon_check.008a726c.svg";